// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageClient_container__GevZQ","main":"LandingPageClient_main__lVRa6"};